(function (){
  const modal = document.getElementById('size-guide-quiz');
  if (!modal) return;

  if (modal.parentElement !== document.body) document.body.appendChild(modal);

  function setSGQTop(){
    const nav = document.getElementById('site-control');
    const h = nav ? nav.offsetHeight : 0;
    modal.style.setProperty('--sgq-nav', h + 'px');
  }
  setSGQTop();
  window.addEventListener('resize', setSGQTop, { passive:true });
  window.addEventListener('scroll', setSGQTop, { passive:true });

  const openBtns  = document.querySelectorAll('[data-open-size-guide],[data-sgq-open]');
  const closeEls  = modal.querySelectorAll('[data-sgq-close], .sgq-overlay');
  const form      = modal.querySelector('.sgq-steps');
  const steps     = Array.from(modal.querySelectorAll('.sgq-step'));
  const resultBox = modal.querySelector('.sgq-result');
  const sizeEl    = modal.querySelector('.sgq-size');
  const lastEl    = modal.querySelector('.sgq-last');
  const stockNote = modal.querySelector('.sgq-stock-note');

  const showModal = () => modal.setAttribute('aria-hidden','false');
  const hideModal = () => modal.setAttribute('aria-hidden','true');
  modal.classList.remove('is-result');

  openBtns.forEach(b => b.addEventListener('click', showModal));
  closeEls.forEach(el => el.addEventListener('click', hideModal));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hideModal(); });

  const chartScript = modal.querySelector('script[id^="sgq-size-chart-"]');
  const availScript = modal.querySelector('script[id^="sgq-available-sizes-"]');
  const chart = JSON.parse(chartScript?.textContent || '{}');
  const availableAll = JSON.parse(availScript?.textContent || '[]');
  const availableEU = Array.from(new Set(
    availableAll.map(t => String(t).trim().split(/[^\d]/)[0]).filter(Boolean)
  ));

  function activeIndex() { return steps.findIndex(s => s.classList.contains('is-active')); }
  function goStepIndex(i){
    steps.forEach((s,idx)=> s.classList.toggle('is-active', idx===i));
    resultBox.hidden = true;
    modal.classList.remove('is-result');
  }
  function validateRequiredIn(stepEl){
    const req = stepEl.querySelectorAll('input[required],select[required],textarea[required]');
    for (const el of req) {
      if (!String(el.value).trim()) { el.focus(); return false; }
      const v = Number(String(el.value).replace(',','.'));
      if (el.type === 'number') {
        if (el.min && v < +el.min) { el.focus(); return false; }
        if (el.max && v > +el.max) { el.focus(); return false; }
      }
    }
    return true;
  }

  // Næste/Tilbage + Rediger (fra resultat)
  modal.addEventListener('click', (e)=>{
    const nextBtn = e.target.closest('.sgq-next');
    const prevBtn = e.target.closest('.sgq-prev');
    const editBtn = e.target.closest('[data-sgq-edit]');

    if (nextBtn){
      const i = activeIndex();
      if (i === -1) return;
      const stepEl = steps[i];
      if (!validateRequiredIn(stepEl)) return;
      goStepIndex(Math.min(i+1, steps.length-1));
    }

    if (prevBtn){
      const i = activeIndex();
      goStepIndex(Math.max(i-1, 0));
    }

    if (editBtn){
      const to = Math.max(1, Math.min(3, parseInt(editBtn.getAttribute('data-edit-step')||'1',10)));
      goStepIndex(to-1); // steps er 0-index
    }
  });

  // Konstanter for beregning
  const TOE_ALLOWANCE = 0;
  const LAST_THRESHOLDS = { SMAL: 0.375, BRED: 0.405 }; // width/length

  function recommendEU(footLenCm, fit){
    const ease = chart?.ease?.[fit] ?? 0.7;
    const target = footLenCm + TOE_ALLOWANCE + ease;
    const entries = Object.entries(chart.eu_cm || {})
      .map(([eu, cm]) => [parseInt(eu,10), cm])
      .sort((a,b)=>a[0]-b[0]);
    if (!entries.length) return null;
    let eu = entries.find(([E,cm]) => cm >= target)?.[0] ?? entries.at(-1)[0];
    return { eu, entries, target };
  }

  function recommendLast(len, wid){
    const r = wid / len;
    if (r < LAST_THRESHOLDS.SMAL) return 'Smal';
    if (r > LAST_THRESHOLDS.BRED) return 'Bred';
    return 'Medium';
  }

  function adjustByLast(eu, last, entries, target){
    if (last === 'Bred') eu = eu + 1;
    if (last === 'Smal') {
      const prev = entries.find(([E]) => E === eu - 1);
      if (prev && prev[1] >= target - 0.2) eu = eu - 1;
    }
    const minEU = entries[0][0], maxEU = entries.at(-1)[0];
    return Math.max(minEU, Math.min(maxEU, eu));
  }

  function nearestAvailable(eu){
    const wanted = String(eu);
    if (availableEU.includes(wanted)) return { eu: wanted, changed:false };
    let up = eu, down = eu;
    for (let i=0;i<6;i++){
      up++; if (availableEU.includes(String(up))) return { eu:String(up), changed:true };
      down--; if (availableEU.includes(String(down))) return { eu:String(down), changed:true };
    }
    return { eu:wanted, changed:false };
  }

  form.addEventListener('submit', (e)=>{
    e.preventDefault();

    const len = Number(String(modal.querySelector('#sgq-foot-l').value || '').replace(',','.'));
    const wid = Number(String(modal.querySelector('#sgq-width').value   || '').replace(',','.'));
    const fit = modal.querySelector('input[name="fit"]:checked')?.value || 'regular';
    if (!len || !wid) return;

    const base = recommendEU(len, fit);
    if (!base) return;

    const last = recommendLast(len, wid);
    let eu = adjustByLast(base.eu, last, base.entries, base.target);

    const near = nearestAvailable(eu);
    stockNote.hidden = !near.changed;

    sizeEl.textContent = `EU ${near.eu}`;
    lastEl.textContent = `— Læst: ${last}`;

    steps.forEach(s => s.classList.remove('is-active'));
    resultBox.hidden = false;
    modal.classList.add('is-result');   // <— add this line


    trySelectVariant(near.eu);
  });

  function trySelectVariant(euStr) {
    const re = new RegExp(`(^|\\s|\\/|-)${euStr}(\\s|\\/|$)`);
    let el = Array.from(document.querySelectorAll(
      '[data-option-item], label, button, .option-selector__btn, .cc-swatches a, .product-option, .product__option'
    )).find(n => re.test(n.textContent?.trim() || ''));
    if (!el) {
      el = Array.from(document.querySelectorAll('input[type="radio"],input[type="button"]'))
        .find(i => re.test(i.value || i.getAttribute('data-value') || ''));
    }
    if (el) (el.closest('label,button,a') || el).click();
  }
})();